import { IAppState } from '../../../AppModulesWrapper';

export const selectAuctionPointsBalance = (state: IAppState): number => {
  return state.servicePickerWidget.balance.auctionPoints;
};
